import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const LaporanPoint6Bulan = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  const [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [surveyorId, setSurveyorId] = useState("");
  const [namaSurveyor, setNamaSurveyor] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapTotalPiutangData, setLapTotalPiutangData] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
    id: surveyor.id,
  }));
  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPoint6Bulan",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (surveyorId.length === 0) {
      alert("Kode Surveyor tidak boleh kosong!");
      return;
    }

    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let laporanPoint6Bulans = await axios.post(
        `${tempUrl}/laporanPoint6Bulan`,
        {
          dariTanggal,
          sampaiTanggal,
          kodeCabang,
          surveyorId,
          _id: user.id,
          token: user.token,
        }
      );
      setLapTotalPiutangData(laporanPoint6Bulans.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    getSurveyorsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getSurveyorsData = async () => {
    const response = await axios.post(`${tempUrl}/surveyors`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setSurveyors(response.data);
  };

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];
  let tempTotalModal = 0;
  let tempTotalBunga = 0;
  let tempTotalDenda = 0;
  let tempTotalPotongan = 0;
  // let tempTotal = 0;

  // for (let j = 0; j < lapTotalPiutangData.length; j++) {
  //   tempTotalModal += lapTotalPiutangData[j].angModal;
  //   tempTotalBunga += lapTotalPiutangData[j].angBunga;
  //   tempTotalDenda += lapTotalPiutangData[j].denda;
  //   tempTotalPotongan += lapTotalPiutangData[j].potongan;
  //   tempTotal += lapTotalPiutangData[j].totalBayar;

  //   list.push(
  //     <tr style={tableText}>
  //       <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
  //         {lapTotalPiutangData[j].no}
  //       </td>
  //       <td style={{ border: "1px solid black" }}>
  //         {lapTotalPiutangData[j].noKwitansi}
  //       </td>
  //       <td style={{ border: "1px solid black" }}>
  //         {lapTotalPiutangData[j].keterangan}
  //       </td>
  //       <td style={textNumberRight}>
  //         {isCetakExcel === false
  //           ? lapTotalPiutangData[j].angModal.toLocaleString("en-EN")
  //           : lapTotalPiutangData[j].angModal}
  //       </td>
  //       <td style={textNumberRight}>
  //         {isCetakExcel === false
  //           ? lapTotalPiutangData[j].angBunga.toLocaleString("en-EN")
  //           : lapTotalPiutangData[j].angBunga}
  //       </td>
  //       <td style={textNumberRight}>
  //         {isCetakExcel === false
  //           ? lapTotalPiutangData[j].denda.toLocaleString("en-EN")
  //           : lapTotalPiutangData[j].denda}
  //       </td>
  //       <td style={textNumberRight}>
  //         {isCetakExcel === false
  //           ? lapTotalPiutangData[j].potongan.toLocaleString("en-EN")
  //           : lapTotalPiutangData[j].potongan}
  //       </td>
  //       <td style={textNumberRight}>
  //         {isCetakExcel === false
  //           ? lapTotalPiutangData[j].totalBayar.toLocaleString("en-EN")
  //           : lapTotalPiutangData[j].totalBayar}
  //       </td>
  //       <td style={{ border: "1px solid black" }}>
  //         {lapTotalPiutangData[j].kasir}
  //       </td>
  //     </tr>
  //   );
  // }

  // list.push(
  //   <tr style={tableText}>
  //     <td style={textBold} colspan="3">
  //       TOTAL :
  //     </td>
  //     <td style={textNumberRightBold}>
  //       {isCetakExcel === false
  //         ? tempTotalModal.toLocaleString("en-EN")
  //         : tempTotalModal}
  //     </td>
  //     <td style={textNumberRightBold}>
  //       {isCetakExcel === false
  //         ? tempTotalBunga.toLocaleString("en-EN")
  //         : tempTotalBunga}
  //     </td>
  //     <td style={textNumberRightBold}>
  //       {isCetakExcel === false
  //         ? tempTotalDenda.toLocaleString("en-EN")
  //         : tempTotalDenda}
  //     </td>
  //     <td style={textNumberRightBold}>
  //       {isCetakExcel === false
  //         ? tempTotalPotongan.toLocaleString("en-EN")
  //         : tempTotalPotongan}
  //     </td>
  //     <td style={textNumberRightBold}>
  //       {isCetakExcel === false ? tempTotal.toLocaleString("en-EN") : tempTotal}
  //     </td>
  //     <td></td>
  //   </tr>
  // );

  let tempPoin = 0;
  let tempP = 0;
  let tempPp = 0;
  let tempPl = 0;
  let tempPk = 0;
  let tempLebihDariSamaDengan90 = 0;
  let tempTotal = 0;
  let tempSisaPoin = 0;

  for (let j = 0; j < lapTotalPiutangData.length; j++) {
    tempPoin += lapTotalPiutangData[j].p + lapTotalPiutangData[j].pl;
    tempP += lapTotalPiutangData[j].p;
    tempPp += lapTotalPiutangData[j].pp;
    tempPl += lapTotalPiutangData[j].pl;
    tempPk += lapTotalPiutangData[j].pk;
    tempLebihDariSamaDengan90 += lapTotalPiutangData[j].lebihDariSamaDengan90;
    tempTotal += lapTotalPiutangData[j].total;
    tempSisaPoin += lapTotalPiutangData[j].total;

    list.push(
      <tr style={tableText}>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {lapTotalPiutangData[j].no}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapTotalPiutangData[j].noPerjanjian}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapTotalPiutangData[j].tglBayarFormatted}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapTotalPiutangData[j].namaCustomer}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapTotalPiutangData[j].alamatCustomer}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapTotalPiutangData[j].marketing}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapTotalPiutangData[j].nopol}
        </td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].tenor}</td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].angPerBulan}</td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].bayarKe}</td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].p}</td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].pp}</td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].pl}</td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].pk}</td>
        <td style={textNumberRight}>
          {lapTotalPiutangData[j].lebihDariSamaDengan90}
        </td>
        <td style={textNumberRight}>{lapTotalPiutangData[j].total}</td>
        <td style={textNumberRight}></td>
      </tr>
    );
  }

  list.push(
    <tr style={tableText}>
      <td style={{ paddingLeft: "15px", border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={{ border: "1px solid black" }}></td>
      <td style={textNumberRight}></td>
      <td style={textNumberRight}></td>
      <td style={textNumberRight}></td>
      <td style={textNumberRight}>{tempP}</td>
      <td style={textNumberRight}>{tempPp}</td>
      <td style={textNumberRight}>{tempPl}</td>
      <td style={textNumberRight}>{tempPk}</td>
      <td style={textNumberRight}>{tempLebihDariSamaDengan90}</td>
      <td style={textNumberRight}>{tempTotal}</td>
      <td style={textNumberRight}></td>
    </tr>
  );

  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Poin</td>
      <td>{tempPoin.toLocaleString("en-US")}</td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Poin Kembali</td>
      <td>{tempPk.toLocaleString("en-US")}</td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">P. Program</td>
      <td>{tempPp.toLocaleString("en-US")}</td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">{">= 90 Hari"}</td>
      <td>{tempLebihDariSamaDengan90.toLocaleString("en-US")}</td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Sisa Poin</td>
      <td>{tempSisaPoin.toLocaleString("en-US")}</td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Nilai Poin</td>
      <td>{setting.nilaiPointSetting.toLocaleString("en-US")}</td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Total</td>
      <td>
        {(tempSisaPoin * parseInt(setting.nilaiPointSetting)).toLocaleString(
          "en-US"
        )}
      </td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Potongan</td>
      <td></td>
    </tr>
  );
  list.push(
    <tr style={textNumberRightBold}>
      <td colspan="2">Total Bersih</td>
      <td>{(tempSisaPoin * 50000).toLocaleString("en-US")}</td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPoint6Bulan",
    sheet: "LaporanPoint6Bulan",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Point 6 Bulan</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    minDate={new Date("2025-01-01")}
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    minDate={new Date("2025-01-01")}
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Surveyor :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={surveyorOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && surveyorId.length === 0 && true}
                        size="small"
                        placeholder="SEMUA SURVEYOR"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setSurveyorId(value.id);
                        setNamaSurveyor(value.label);
                      } else {
                        setSurveyorId("");
                        setNamaSurveyor("");
                      }
                      setPreviewPdf(false);
                    }}
                    defaultValue={surveyorId}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Point 6 Bulan
          </h5>
          <p>Cabang : {namaCabang}</p>
          <p>Surveyor : {namaSurveyor}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>No</th>
                <th style={{ border: "1px solid black" }}>Kontrak</th>
                <th style={{ border: "1px solid black" }}>Tanggal</th>
                <th style={{ border: "1px solid black" }}>Nama</th>
                <th style={{ border: "1px solid black" }}>Alamat</th>
                <th style={{ border: "1px solid black" }}>Marketing</th>
                <th style={{ border: "1px solid black" }}>No. BP</th>
                <th style={{ border: "1px solid black" }}>JW</th>
                <th style={{ border: "1px solid black" }}>Ang</th>
                <th style={{ border: "1px solid black" }}>Ke</th>
                <th style={{ border: "1px solid black" }}>P</th>
                <th style={{ border: "1px solid black" }}>PP</th>
                <th style={{ border: "1px solid black" }}>PL</th>
                <th style={{ border: "1px solid black" }}>PK</th>
                <th style={{ border: "1px solid black" }}>{">90"}</th>
                <th style={{ border: "1px solid black" }}>TTL</th>
                <th style={{ border: "1px solid black" }}>Potongan</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPoint6Bulan;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};
